import {Component} from '@angular/core';

@Component({
  selector: 'jhi-personal-data',
  templateUrl: './personal-data.component.html',
  styleUrls: ['./personal-data.component.scss']
})
export class PersonalDataComponent {

    constructor() {
    }

    scroll(id: string) {
        let el = document.getElementById(id);
        el.scrollIntoView();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/footer/personal-data/personal-data.component.ts